/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PlatformKillswitchPrescription = {
  activatedAt?: Date | undefined;
  definition: string;
  expiresAt?: Date | undefined;
  externalNote: string;
  id: string;
  internalNote: string;
  organizationId: string;
  principalKey: string;
  principalKind: string;
  resourceKind: string;
  resourceScope: string;
  selectedResourceKeys: Array<string>;
  startsAt: Date;
  state: string;
  supersededAt?: Date | undefined;
  version: number;
};

/** @internal */
export const PlatformKillswitchPrescription$inboundSchema: z.ZodMiniType<
  PlatformKillswitchPrescription,
  unknown
> = z.pipe(
  z.object({
    activated_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    definition: z.string(),
    expires_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    external_note: z.string(),
    id: z.string(),
    internal_note: z.string(),
    organization_id: z.string(),
    principal_key: z.string(),
    principal_kind: z.string(),
    resource_kind: z.string(),
    resource_scope: z.string(),
    selected_resource_keys: z.array(z.string()),
    starts_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    state: z.string(),
    superseded_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    version: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "activated_at": "activatedAt",
      "expires_at": "expiresAt",
      "external_note": "externalNote",
      "internal_note": "internalNote",
      "organization_id": "organizationId",
      "principal_key": "principalKey",
      "principal_kind": "principalKind",
      "resource_kind": "resourceKind",
      "resource_scope": "resourceScope",
      "selected_resource_keys": "selectedResourceKeys",
      "starts_at": "startsAt",
      "superseded_at": "supersededAt",
    });
  }),
);

export function platformKillswitchPrescriptionFromJSON(
  jsonString: string,
): SafeParseResult<PlatformKillswitchPrescription, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PlatformKillswitchPrescription$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PlatformKillswitchPrescription' from JSON`,
  );
}
